module.exports = __webpack_public_path__ + "img/SKMJ_place10.08d09ac3.jpg";